import axios from "axios";
import { tmsApi, localApi } from "../api";

export const getInvoiceCorrectionsList = (obj) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/tripinvoicecorrection/getinvoicecorrectionlist/${obj.serviceCityId}?page=${obj.page}&size=${obj.size}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const confirmationOtp = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .post(
                tmsApi +
                `v1/tripinvoicecorrection/sendconfirmationotp`,
                obj,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const validateConfirmationOtp = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .post(
                tmsApi +
                `v1/tripinvoicecorrection/validateconfirmationotp`,
                obj,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const submitDutyRegister = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .post(
                tmsApi +
                `v1/tripinvoicecorrection/invoicecorrectionupdate`,
                obj,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const checkInvoiceAllow = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .get(
                tmsApi +
                `v1/tripinvoicecorrection/checkinvoicecorrectionallow/${obj.bookingNo}`,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getCustomerInvoice = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .get(
                tmsApi +
                `v1/services/customerinvoice/${obj.tripId}`,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const recalculateInvoiceCorrection = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            CheckId : "4d40370d-e945-44c8-a95f-dc9bec47e3cf",
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .post(
                tmsApi +
                `v1/tripinvoicecorrection/invoicecorrection`,
                obj,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createInvoiceCorrection = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .post(
                tmsApi +
                `v1/tripinvoicecorrection/createinvoicecorrection`,
                obj,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const updateInvoiceCorrection = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .put(
                tmsApi +
                `v1/tripinvoicecorrection/updateinvoicecorrection`,
                obj,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getInvoiceCorrection = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .get(
                tmsApi +
                `v1/tripinvoicecorrection/getinvoicecorrection/${obj.bookingNo}`,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
export const getInvoiceCorrectionReasons= async(obj)=>{
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .get(
                tmsApi +
                `v1/tripinvoicecorrection/getinvoicereasons`, 
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
}
export const getTripByBookingNo = async (obj) => {
    const config = {
        headers: {
            token: `${localStorage.getItem("token")}`,
            "Access-Control-Allow-Origin": "*",
        },
    };
    try {
        return axios
            .get(
                tmsApi +
                `v1/entities/trip/detail/bybookingno/${obj.bookingNo}`,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};